import { relaunch } from '@tauri-apps/plugin-process'
import { Update, check } from '@tauri-apps/plugin-updater'
import { toaster } from 'components'
import { useEffect, useRef } from 'react'
import { version } from '../../package.json'
import { useConfiguration } from './dbUtils'
import { isDesktop } from './helpers'

let update: Update | null = null

export function useUpdater() {
  const config = useConfiguration()
  const shownToast = useRef(false)

  useEffect(() => {
    if (!config || !isDesktop) return

    const forceUpdate = version < config.minAppVersion
    checkForUpdates(forceUpdate)
  }, [config])

  async function checkForUpdates(forceUpdate?: boolean) {
    update = await check()
    if (!update) return

    if (forceUpdate) return updateSW()

    if (shownToast.current) return
    shownToast.current = true

    toaster.create({
      type: 'info',
      duration: 999999,
      title: 'Update available',
      closable: true,
      action: {
        label: 'Update',
        onClick: () => updateSW(),
      },
    })
  }
}

async function updateSW(callback?: (progress: number) => void) {
  if (!update) return

  console.log(`Updating to ${update.version} from ${update.date}`)

  let downloaded = 0
  let contentLength = 0

  await update.downloadAndInstall(event => {
    switch (event.event) {
      case 'Started':
        contentLength = event.data.contentLength ?? 0
        break
      case 'Progress':
        downloaded += event.data.chunkLength
        callback?.(downloaded / contentLength)
        break
      case 'Finished':
        break
    }
  })

  await relaunch()
}
